import type { ApiOrgMini } from 'modules/listing/api/org/types/ApiOrgMini';

type Props = {
  orgNameOverride: string | null;
  isPostedAnonymously: boolean;
  org: ApiOrgMini | null;
};

export function getOrgName({
  orgNameOverride,
  isPostedAnonymously,
  org,
}: Props) {
  return orgNameOverride || (isPostedAnonymously ? '' : org?.name);
}
